<div class="overlay"></div>
<aside id="leftsidebar" class="sidebar">
  <div class="navbar-brand">
    <a [routerLink]="['dashboard']">
      <img src="./assets/images/logo.png" alt=""
    /></a>
    <button class="btn-menu ls-toggle-btn" type="button">
      <span class="icon-bars" (click)="toggleMenu($event)"></span>
    </button>
  </div>
  <div class="menu">
    <ul class="list">
      <li>
        <div class="user-info">
          <br />
          <!-- <a class="image" href="profile.html"><img src="/assets/images/profile_av.jpg" alt="User"></a> -->
          <div class="detail">
            <h4>Restaurant Name</h4>
            <small>Human Resource Department</small>
          </div>
        </div>
      </li>
      <li
        *ngFor="let menuOption of menuOptions; let i = index"
        (click)="toggleDropdown($event, menuOption)"
      >
        <a *ngIf="menuOption.routeLink" [routerLink]="[menuOption.routeLink]">
          <i class="{{ 'zmdi' + ' ' + menuOption.icon }}"></i>
          <span>{{ menuOption.menuText }}</span>
        </a>
        <a
          href="javascript:void(0);"
          *ngIf="!menuOption.routeLink"
          [class.toggled]="menuOption.isClicked"
          [class.menu-toggle]="menuOption.extras.length"
        >
          <i class="{{ 'zmdi' + ' ' + menuOption.icon }}"></i>
          <span>{{ menuOption.menuText }}</span>
        </a>
        <ng-container
          [ngTemplateOutlet]="subMenu"
          [ngTemplateOutletContext]="{ menu: menuOption }"
        ></ng-container>
      </li>
    </ul>
  </div>
</aside>
<ng-template #subMenu let-menu="menu">
  <ul
    class="ml-menu sub-list"
    [class.d-block]="menu.isClicked"
    *ngIf="menu.extras && menu.extras.length"
  >
    <li
      *ngFor="let sub of menu.extras; let index = index"
      (click)="toggleDropdown($event, sub)"
    >
      <a *ngIf="sub.routeLink" [routerLink]="[sub.routeLink]">
        {{ sub.menuText }}
      </a>
      <a
        href="javascript:void(0);"
        class="sub"
        *ngIf="!sub.routeLink"
        [class.toggled]="sub.isClicked"
        [class.menu-toggle]="sub.extras && sub.extras.length"
      >
        {{ sub.menuText }}
      </a>
      <ng-container
        [ngTemplateOutlet]="subMenu"
        [ngTemplateOutletContext]="{ menu: sub }"
      ></ng-container>
    </li>
  </ul>
</ng-template>
